import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import MainLayout from 'layout/MainLayout';
import { element } from 'prop-types';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const AuthRegister = Loadable(
  lazy(() => import('pages/authentication/Register'))
);
const AuthForgotPassword = Loadable(
  lazy(() => import('pages/authentication/ForgotPassword'))
);
const AuthChangeNewPassword = Loadable(
  lazy(() => import('pages/authentication/ChangeNewPassword')) //changed1
);
const AuthOTPVerification = Loadable(
  lazy(() => import('pages/authentication/OTPVerification'))
);
const GoogleRedirect = Loadable(
  lazy(() => import('pages/authentication/GoogleRedirect'))
);

// render - main
// Comments might not be accurate
// render - bidding page
const BiddingPage = Loadable(lazy(() => import('pages/bidding/BiddingPage')));
const StarredBidsPage = Loadable(lazy(() => import('pages/bidding/StarredBidsPage')));

// render - manage users & companies admin page
const ManageUsersPage = Loadable(lazy(() => import('pages/manageUsers/index')));
const ManageCompaniesPage = Loadable(lazy(() => import('pages/manageCompanies/index')));

// render - manage users admin page
const ManageBidsPage = Loadable(
  lazy(() => import('pages/manageBids/allBids/index'))
);
const ManageBuyNowPage = Loadable(
  lazy(() => import('pages/manageBuyNow/manageBuyNow'))
);


// render - select bid admin page
const SelectedBidsPage = Loadable(
  lazy(() => import('pages/manageBids/selectedBid/index'))
);

// render - award bid admin page
const AwardBidsPage = Loadable(
  lazy(() => import('pages/manageBids/awardBid/index'))
);

// render - dashboard
const FavouritePage = Loadable(lazy(() => import('pages/myFavourite')));

// render - sample home page
const HomePage = Loadable(lazy(() => import('pages/home/HomePage')));

const TermsPage = Loadable(lazy(() => import('pages/extra-pages/terms')));

const FeedbackPage = Loadable(lazy(() => import('pages/extra-pages/feedback')));

// render - sample my bids page
const MyBidsPage = Loadable(lazy(() => import('pages/mybids/MyBids')));

const BuyNowPage = Loadable(lazy(() => import('pages/buyNow/buyNow')));

// render - sample past biddings page
const PassBiddingsPage = Loadable(
  lazy(() => import('pages/pastBiddings/PastBiddings'))
);

// render - sample most popular cars page
const MostPopularCarsPage = Loadable(
  lazy(() => import('pages/popularCars/PopularCars'))
);

// render - sample add favourite page
const AddFavouritePage = Loadable(lazy(() => import('pages/myFavourite/AddFavourite')));
const TestFavouritesPage = Loadable(lazy(() => import('pages/testFavourite')));

// render
const VehicleList = Loadable(lazy(() => import('pages/vehicle/VehicleList')));
const VehicleSheet = Loadable(lazy(() => import('pages/vehicle/VehicleSheet')));
const SubmissionList = Loadable(lazy(() => import('pages/vehicle/SubmissionList')));
const MakeModelList = Loadable(lazy(() => import('pages/vehicle/MakeModelList')));
const CreateVehicle = Loadable(
  lazy(() => import('pages/vehicle/CreateVehicle'))
); // old
const NewVehicle = Loadable(
  lazy(() => import('pages/vehicle/NewVehicle'))
); // new
const EditVehicle = Loadable(lazy(() => import('pages/vehicle/EditVehicle')));
const SubmitVehicle = Loadable(
  lazy(() => import('pages/vehicle/SubmitVehicle'))
);
const ManualOffer = Loadable(
  lazy(() => import('pages/vehicle/ManualOffer'))
);
const AuctionCalendar = Loadable(
  lazy(() => import('pages/auction/AuctionCalendar'))
);
const AuctionDetail = Loadable(
  lazy(() => import('pages/auction/AuctionDetail'))
);
//render - Manage bids
const AllCommentsPage = Loadable(
  lazy(() => import('pages/manageBids/allBids/AllComments'))
);

// render settings
const SettingsPage = Loadable(lazy(() => import('pages/settings')));
const AccountSettings = Loadable(
  lazy(() => import('pages/settings/settings-forms/Account'))
);
const CompanySettings = Loadable(
  lazy(() => import('pages/settings/settings-forms/Company'))
);
const AdminSettings = Loadable(
  lazy(() => import('pages/settings/settings-forms/Admin'))
);

// render - Create Public User
const CreatePublicUser = Loadable(
  lazy(() => import('pages/user/CreatePublicUser'))
);

// render - Create Company
const CreateCompany = Loadable(
  lazy(() => import('pages/company/CreateCompany'))
);

const EditCompany = Loadable(
  lazy(() => import('pages/company/EditCompany'))
);


// ==============================|| AUTH ROUTING ||============================== //


const routes = (user) => [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: user ? <Navigate to='/dash' /> : <Navigate to='/login'/> },
      //{ path: 'submitVehicle', element: <SubmitVehicle /> },
      { path: 'google/redirect', element: <GoogleRedirect /> },
      { path: 'pastbiddings', element: <PassBiddingsPage /> },
      { path: 'popularcars', element: <MostPopularCarsPage /> },
      { path: 'terms', element: <TermsPage /> },
      {path: "feedback", element: <FeedbackPage />}
    ],
  },
  {
    path: '/',
    element: !user ? <MinimalLayout /> : <Navigate to='/dash' />,
    children: [
      { path: 'login', element: <AuthLogin /> },
      { path: 'register', element: <AuthRegister /> },
      { path: 'forgotpassword', element: <AuthForgotPassword /> },
      { path: 'changenewpassword', element: <AuthChangeNewPassword /> }, //changed1
      { path: 'otpverification', element: <AuthOTPVerification /> }, 
    ],
  },
  // protected routes
  {
    path: 'dash',
    element: user ? <MainLayout /> : <Navigate to='/login' />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'mybids', element: <MyBidsPage /> },
      { path: 'buynow', element: <BuyNowPage /> },
      { path: 'favourite', element: <FavouritePage /> },
      { path: 'addfavourite', element: <AddFavouritePage /> },
      { path: 'awardBids', element: <AwardBidsPage /> },
      { path: 'bidding', element: <BiddingPage /> },
      { path: 'bidding/starred', element: <StarredBidsPage /> },
    ],
  },
  {
    path: 'settings',
    element: user ? <MainLayout /> : <Navigate to='/login' />,
    children: [
      {
        element: <SettingsPage />,
        children: [
          { path: 'account', element: <AccountSettings /> },
          { path: 'company', element: <CompanySettings /> },
          { path: 'admin', element: (user?.UserType === "ADMIN" || user?.UserType === "SADMIN") ? <AdminSettings /> : <Navigate to='/settings/account' /> },
        ],
      },
    ],
  },
  {
    path: 'admin',
    element:
      (user?.UserType === 'ADMIN' || user?.UserType === "SADMIN") ? <MainLayout /> : <Navigate to='/login' />,
    children: [
      { path: 'manageUsers', element: <ManageUsersPage /> },
      { path: 'manageCompanies', element: <ManageCompaniesPage /> },
      { path: 'manageBids', element: <ManageBidsPage /> },
      { path: 'manageBuyNow', element: <ManageBuyNowPage /> },
      { path: 'vehicleList', element: <VehicleList /> },
      { path: 'vehicleSheet', element: <VehicleSheet /> },
      { path: 'submissionList', element: <SubmissionList /> },
      { path: 'manageMakeModel', element: <MakeModelList /> },
      { path: 'createVehicle', element: <NewVehicle /> },
      { path: 'manualOffer', element: <ManualOffer /> },
      { path: 'editVehicle/:VehicleId', element: <EditVehicle /> },
      { path: 'auctionCalendar', element: <AuctionCalendar /> },
      { path: 'auctionDetail/:AuctionId', element: <AuctionDetail /> },
      { path: 'manageComments', element: <AllCommentsPage /> },
      { path: 'selectBids', element: <SelectedBidsPage /> },
      { path: 'testFavourites', element: <TestFavouritesPage /> },
      { path: 'createPublicUser', element: <CreatePublicUser/> },
      { path: 'createCompany', element: <CreateCompany/> },
      { path: 'editCompany/:CompanyId', element: <EditCompany/> }
    ],
  },
];

export default routes;
